import { createSlice } from "@reduxjs/toolkit";
import {
  fetchShowcases
} from "../actions/showcasesActions";

const initialState = {
  showcases: [],
  currentShowcase: null,
  loading: false,
  error: null,
};

const showcaseSlice = createSlice({
  name: "showcases",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH ALL
      .addCase(fetchShowcases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShowcases.fulfilled, (state, action) => {
        state.loading = false;
        state.showcases = action.payload.data ?? action.payload;
      })
      .addCase(fetchShowcases.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default showcaseSlice.reducer;
